<tui-editor
  class="editor"
  [class.editor_invalid]="control && control.errors !== null"
  [(ngModel)]="value"
  [tools]="tools"
  [placeholder]="placeholder"
></tui-editor>

<tui-error
  *ngIf="control?.errors?.maxlength.requiredLength as errorText"
  [error]="'common.labels.maxLengthError' | translate: { value: errorText }"
></tui-error>
